import { MDBIcon, MDBSpinner } from "mdb-react-ui-kit";
import classnames from 'classnames';
import ApiService from "../../Core/Service/ApiService";
import { useEffect, useState } from "react";

const CategoryTree = (props) => {
    const { categories, setCategories } = props;
    const [action, setAction] = useState();

    const expandCategory = (e, category, expand) => {
        e.stopPropagation();

        setCategories(categories.map(cat => {
            if (cat.category_id != category.category_id) {
                return cat;
            } else {
                return {
                    ...cat,
                    expand
                }
            }
        }))
    }

    const onCategorySelected = (e, category) => {
        e.stopPropagation();

        const sc = {
            ...category,
            active: true,
        }

        setCategories(categories.map(cat => {
            if (cat.category_id == category.category_id) {
                return sc;
            } else {
                return {
                    ...cat,
                    active: false,
                };
            }
        }))

        props.onCategorySelected && props.onCategorySelected(sc);
    }

    const handleMoveUp = (category) => {
        setAction({
            action: 'move_up',
            category_id: category.category_id
        })
        ApiService.post(`/categories/${category.category_id}/move/up`).then(response=> {
            const swappedCategories = response.data.swappedCategories;
            if(swappedCategories?.length > 0) {
                setCategories(categories.map(c => {
                    const category = swappedCategories.find(c1 => c1.category_id == c.category_id);
                    return category ?? c;
                }).sort((c1, c2) => c1.sequence - c2.sequence))
            }
        }).finally(() => {
            setAction();
        })
    }

    const handleMoveDown = (category) => {
        setAction({
            action: 'move_down',
            category_id: category.category_id
        })
        ApiService.post(`/categories/${category.category_id}/move/down`).then(response=> {
            const swappedCategories = response.data.swappedCategories;
            if(swappedCategories?.length > 0) {
                setCategories(categories.map(c => {
                    const category = swappedCategories.find(c1 => c1.category_id == c.category_id);
                    return category ?? c;
                }).sort((c1, c2) => c1.sequence - c2.sequence));
            }
        }).finally(() => {
            setAction();
        })
    }

    const renderCategories = (cats, level) => {
        return (
            <ul className={`category-treeitems level-${level}`}>
                {cats?.map((cat, index) => {
                    const sub_categories = categories.filter(sc => sc.parent_id == cat.category_id);
                    return (
                        < li
                            onClick={(e) => onCategorySelected(e, cat)}
                            key={index}
                            className={classnames({
                                'expand': cat.expand && sub_categories?.length > 0,
                                'active': cat.active
                            })}
                        >
                            <div className="category-name d-flex align-items-center">
                                <div className="flex-fluid">{cat.category_name}</div>
                                <div className="d-flex align-items-center">
                                    <span className="me-3">
                                        {!(action && action.action == 'move_up' && action.category_id == cat.category_id) && (
                                            <MDBIcon 
                                                fas icon="long-arrow-alt-up me-1" 
                                                size={level == 0 ? "lg" : 'md'} 
                                                color="success" 
                                                onClick={e=>handleMoveUp(cat)}
                                            /> 
                                        )}
                                        {(action && action.action == 'move_up' && action.category_id == cat.category_id) && (
                                            <MDBSpinner size="sm" />
                                        )}

                                        {!(action && action.action == 'move_down' && action.category_id == cat.category_id) && (
                                            <MDBIcon 
                                                fas icon="long-arrow-alt-down" 
                                                size={level == 0 ? 'lg' : 'md'} 
                                                color="success" 
                                                onClick={e=>handleMoveDown(cat)}
                                            />
                                        )}
                                        {(action && action.action == 'move_down' && action.category_id == cat.category_id) && (
                                            <MDBSpinner size="sm" />
                                        )}
                                    </span>

                                    <span>
                                        {sub_categories?.length > 0 && cat.expand == true && (
                                            <MDBIcon fas icon="angle-up" onClick={e => expandCategory(e, cat, false)} />
                                        )}
                                        {sub_categories?.length > 0 && cat.expand != true && (
                                            <MDBIcon fas icon="angle-down" onClick={e => expandCategory(e, cat, true)} />
                                        )}
                                        {(level == 0 && !(sub_categories?.length > 0)) && <span style={{paddingLeft: 2, paddingRight:3}}>&nbsp;</span>}
                                    </span>
                                </div>
                            </div>
                            {cat.expand && sub_categories?.length > 0 && renderCategories(sub_categories, level + 1)}
                        </li>
                    )
                })}
            </ul >
        )
    }

    const top_categories = categories?.filter(cat => cat.parent_id == '0');
    return (
        <div className="category-tree">
            {top_categories?.length > 0 && renderCategories(top_categories, 0)}
        </div>
    )
}

export default CategoryTree;